import { notification } from 'antd';
import { GetNotificationProps } from 'common/utils/utility';
import { APIResponseCode, MessageDisplay, TransactionStatus } from 'common/constants';
import { APIResponse, PostData } from 'common/utils/jsonFetch';
import { Validator } from 'common/validators/validators';
import { HandleErrorMessage } from '@features/Common';
import { KFSEndpoints } from 'common/constants/KFSEndpoints';
import { DashboardActions } from '../store/DashboardSlice';
import {
  ContainerDashboardCriticalModel,
  ContainerDashboardModel,
  KFSUserDashboardModel,
  TransactionDashboardModel,
  UserDashboardModel,
} from 'common/models/DashboardModel';

export const GetContainerDashboardByContainerId = (containerId: string) => async (dispatch) => {
  const methodName = 'GetContainerDashboardByContainerId';

  try {
    dispatch(DashboardActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.Dashboard_GetContainerDashboard, containerId);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    dispatch(DashboardActions.submitStatusSucceeded());
    const data: ContainerDashboardModel[] = response.parsedBody?.Results;
    dispatch(DashboardActions.SetContainerDashboardList(data));
  } catch (e) {
    dispatch(DashboardActions.submitStatusRejected(HandleErrorMessage(methodName, e)));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
    throw e;
  }
};

export const GetContainerDashboardCriticalByContainerId = (containerId: string) => async (dispatch) => {
  const methodName = 'GetContainerDashboardCriticalByContainerId';

  try {
    dispatch(DashboardActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.Dashboard_GetContainerDashboardCritical, containerId);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    dispatch(DashboardActions.submitStatusSucceeded());
    const data: ContainerDashboardCriticalModel[] = response.parsedBody?.Results;
    dispatch(DashboardActions.SetContainerDashboardCriticalList(data));
  } catch (e) {
    dispatch(DashboardActions.submitStatusRejected(HandleErrorMessage(methodName, e)));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
    throw e;
  }
};

export const GetUserDashboard = () => async (dispatch) => {
  const methodName = 'GetUserDashboard';

  try {
    dispatch(DashboardActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.Dashboard_GetUserDashboard, '');
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    dispatch(DashboardActions.submitStatusSucceeded());
    const data: UserDashboardModel[] = response.parsedBody?.Results;
    dispatch(DashboardActions.SetUserDashboardList(data));
  } catch (e) {
    dispatch(DashboardActions.submitStatusRejected(HandleErrorMessage(methodName, e)));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
    throw e;
  }
};

export const GetKFSDashboard = () => async (dispatch) => {
  const methodName = 'GetKFSDashboard';

  try {
    dispatch(DashboardActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.Dashboard_GetKFSDashboard, '');
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    dispatch(DashboardActions.submitStatusSucceeded());
    const data: KFSUserDashboardModel[] = response.parsedBody?.Results;
    dispatch(DashboardActions.SetKFSUserDashboardList(data));
  } catch (e) {
    dispatch(DashboardActions.submitStatusRejected(HandleErrorMessage(methodName, e)));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
    throw e;
  }
};

export const GetTransactionDashboard = (status: string) => async (dispatch) => {
  const methodName = 'GetTransactionDashboard';

  try {
    dispatch(DashboardActions.submitStatus());
    switch (status) {
      case TransactionStatus.NW:
        dispatch(DashboardActions.SetTransactionNewDashboardList([]));
        break;
      case TransactionStatus.PI:
        dispatch(DashboardActions.SetTransactionPickupDashboardList([]));
        break;
      case TransactionStatus.FD:
        dispatch(DashboardActions.SetTransactionDropoffDashboardList([]));
        break;
      default:
        break;
    }

    const response = await PostData<APIResponse>(KFSEndpoints.Dashboard_GetTransactionDashboard, status);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    dispatch(DashboardActions.submitStatusSucceeded());
    const data: TransactionDashboardModel[] = response.parsedBody?.Results;
    switch (status) {
      case TransactionStatus.NW:
        dispatch(DashboardActions.SetTransactionNewDashboardList(data));
        break;
      case TransactionStatus.PI:
        dispatch(DashboardActions.SetTransactionPickupDashboardList(data));
        break;
      case TransactionStatus.FD:
        dispatch(DashboardActions.SetTransactionDropoffDashboardList(data));
        break;
      default:
        break;
    }
  } catch (e) {
    dispatch(DashboardActions.submitStatusRejected(HandleErrorMessage(methodName, e)));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
    throw e;
  }
};
